<template>
  <div class="bg">
    <div class="content">
      <el-card>
        <el-form
          ref="pwForm"
          :model="pwForm"
          status-icon
          label-width="auto"
          :rules="rules"
          class="status-icon"
        >
          <el-form-item
            label="原密码："
            prop="beforePw"
          >
            <el-input
              v-model="pwForm.boforePw"
              type="password"
              clearable
              size="small"
              placeholder="请输入原密码"
            />
          </el-form-item>
          <el-form-item
            label="新密码："
            prop="newPw"
          >
            <el-input
              v-model="pwForm.newPw"
              type="password"
              autocomplete="off"
              clearable
              size="small"
              placeholder="请输入新密码"
            />
          </el-form-item>
          <el-form-item
            label="确认密码："
            prop="checkPw"
          >
            <el-input
              v-model="pwForm.checkPw"
              type="password"
              autocomplete="off"
              clearable
              size="small"
              placeholder="请再次输入新密码"
            />
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('pwForm')">
              重置
            </el-button>
            <el-button
              type="primary"
              @click="submitForm('pwForm')"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var validateNewPw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 4) {
        callback(new Error("密码至少输入四位"));
      } else {
        if (this.pwForm.checkPw !== "") {
          this.$refs.pwForm.validateField("checkPw");
        }
        callback();
      }
    };
    var validateCheckPw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.pwForm.newPw) {
        callback(new Error("两次输入密码不一致！"));
      } else {
        callback();
      }
    };
    return {
      pwForm: {
        afterPw: "",
        newPw: "",
        checkPw: "",
      },
      rules: {
        afterPw: [{}],
        newPw: [{ validator: validateNewPw, trigger: "blur" }],
        checkPw: [{ validator: validateCheckPw, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 提交修改密码表单
    submitForm(pwForm) {
      this.$refs[pwForm].validate((valid) => {
        if (valid) {
          this.$notify({ type: "primary", message: "修改成功" });
          this.$refs[pwForm].resetFields();
        } else {
          this.$notify.error({ message: "修改失败" });
          return false;
        }
      });
    },
    // 修改密码表单重置
    resetForm(pwForm) {
      this.$refs[pwForm].resetFields();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  min-height: 100vh;
  background-color: #f0f0f0;
}
.content {
  padding: 10px;
}
.el-form-item {
  margin-bottom: 15px;
}
</style>
